export default __webpack_public_path__ + "static/media/finleys_reise_nach_pandemia_cover.e4979b26.webp";